import { useState, useEffect } from "react";
import { BaseUrl } from "../../../common/config";
import RichTextEditor from "../../../common/richTextEditor";
import ConfirmationPopup from "../../../common/confirmationPopup";
import { useTranslation } from "react-i18next";
const HeroSectionEditor = ({ section, onUpdate, onSave, isSaving }) => {
  const { t } = useTranslation();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [formData, setFormData] = useState(
    section || {
      title: "",
      subtitle: "",
      ctaText: "",
      ctaLink: "",
      videoUrl: "",
      videoFile: null,
      videoFileName: "",
    },
  );
  const videoType = formData.videoType || (formData.videoFileUrl || formData.videoFile ? "upload" : "url");
  // Sync formData with incoming section prop
 useEffect(() => {
  if (section) {
    setFormData(section);
  }
}, [section]);
  // Handle changes for plain text inputs (CTA text/link and video URL)
  const handlePlainChange = (e) => {
    const { name, value } = e.target;
    const updatedData = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedData);
    if (onUpdate) {
      onUpdate(updatedData);
    }
  };
  // Handle video file selection
  const handleVideoFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const updatedData = {
        ...formData,
        videoFile: file,
        videoFileName: file.name,
      };
      setFormData(updatedData);
      if (onUpdate) {
        onUpdate(updatedData);
      }
    }
  };
  // Handle removing the uploaded video
  const handleRemoveVideo = () => {
    setFormData((prev) => {
      const updated = {
        ...prev,
        videoFile: null,
        videoFileUrl: "",
        videoFileName: "",
      };
      onUpdate && onUpdate(updated);
      return updated;
    });
  };
  const handleVideoTypeChange = (selected) => {
    const updated = {
      ...formData,
      videoType: selected,
    };
    setFormData(updated);
    onUpdate && onUpdate(updated);
  };
  // Render the form fields for editing the hero section
  return (
    <div className="section-editor">
      <div className="input-field">
        <label>{t("section_title_txt")}</label>
        <RichTextEditor
          emailContent={formData.title || ""}
          handleChangeEmailContent={(html) => {
            const updatedData = {
              ...formData,
              title: html,
            };
            setFormData(updatedData);
            onUpdate && onUpdate(updatedData);
          }}
          readOnly={false}
        />
      </div>
      <div className="input-field">
        <label>{t("section_description_txt")}</label>
        <RichTextEditor
          emailContent={formData.subtitle || ""}
          handleChangeEmailContent={(html) => {
            const updatedData = {
              ...formData,
              subtitle: html,
            };
            setFormData(updatedData);
            onUpdate && onUpdate(updatedData);
          }}
          readOnly={false}
        />
      </div>
      <div className="input-field">
        <label>{t("button_text_txt")}</label>
        <input
          type="text"
          name="ctaText"
          value={formData.ctaText || ""}
          onChange={handlePlainChange}
          placeholder={t("btn_placeholder_txt")}
        />
      </div>
      {/* <div className="input-field">
        <label>{t("button_link_txt")}</label>
        <input
          type="text"
          name="ctaLink"
          value={formData.ctaLink || ""}
          onChange={handlePlainChange}
          placeholder={t("btn_link_placeholder_txt")}
        />
      </div> */}
      <div className="input-field col-1">
        <label>{t("select_video_type_txt")}</label>
        <div className="edit-free-cat-chks">
          <div className="check-box">
            <input
              type="radio"
              id="videoUpload"
              name="videoType"
              value="upload"
              checked={videoType === "upload"}
              onChange={(e) => handleVideoTypeChange(e.target.value)}
            />
            <label htmlFor="videoUpload">
              {t("upload_video_txt")}
            </label>
          </div>
          <div className="check-box">
            <input
              type="radio"
              id="videoUrl"
              name="videoType"
              value="url"
              checked={videoType === "url"}
              onChange={(e) => handleVideoTypeChange(e.target.value)}
            />
            <label htmlFor="videoUrl">
              {t("videourl_txt")}
            </label>
          </div>
        </div>
      </div>
      <div className="notification-field-set vendor-cms-field-set flex-input-row col-2">
        {videoType === "upload" && (
        <div className="input-field">
          <label>
            {t("upload_video_file_txt")}
            <span className="text-note">
              {" "}
              {t("max_video_file_size_txt")}
            </span>
          </label>
          <input
            type="file"
            accept="video/*"
            onChange={handleVideoFileChange}
          />
          {/* Show existing uploaded video */}
          {(formData.videoFileUrl || formData.videoFile) && (
            <div className="flex align-center gap-10">
              <div className="upld-img-file">
                <h6>{t("current_uploaded_video_txt")}</h6>
                <div className="upld-img-preview">
                  <video
                    width="400"
                    controls
                    src={
                      formData.videoFile
                        ? URL.createObjectURL(formData.videoFile) // NEW UPLOAD PREVIEW
                        : `${BaseUrl}${formData.videoFileUrl}` // FETCHED VIDEO
                    }
                  />
                  <a
                    className="title-tooltip title-up delete-img"
                    data-title={t("delete_txt")}
                    onClick={() => setShowDeletePopup(true)}
                  >
                    <i className="fa fa-trash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
        )}
        {videoType === "url" && (
          <div className="input-field">
            <label>{t("video_url_txt")}</label>
            <input
              type="text"
              name="videoUrl"
              value={formData.videoUrl || ""}
              onChange={handlePlainChange}
              placeholder={t("video_url_placeholder_txt")}
            />
          </div>
        )}
      </div>
      <div className="btnfield justify-space">
        <button
          type="button"
          onClick={() => onSave && onSave("hero", formData)}
          disabled={isSaving}
        >
          {isSaving ? t("saving_txt") : t("save_section_txt")}
        </button>
      </div>
      {showDeletePopup && (
        <ConfirmationPopup
          title={t("confirm_txt")}
          confirmationMessage={t("confirm_delete_video_txt")}
          handleYes={() => {
            handleRemoveVideo();
            setShowDeletePopup(false);
          }}
          handleNo={() => setShowDeletePopup(false)}
        />
      )}
    </div>
  );
};
export default HeroSectionEditor;